var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistEmpty = function SvgWishlistEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Wishlist-empty_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 1400 950"
    },
    viewBox: "0 0 1400 950"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Wishlist-empty_svg__st3{fill:#d70b17}.Wishlist-empty_svg__st4{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M1106.1 514.9H139.6c-53.4 0-96.7-43.3-96.7-96.7 0-53.4 43.3-96.7 96.7-96.7h966.5c53.4 0 96.7 43.3 96.7 96.7 0 53.4-43.3 96.7-96.7 96.7z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.4 708.3H402c-53.4 0-96.7-43.3-96.7-96.7 0-53.4 43.3-96.7 96.7-96.7h858.4c53.4 0 96.7 43.3 96.7 96.7 0 53.4-43.3 96.7-96.7 96.7z",
    style: {
      fill: "#f6f5f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.1 900.9H213.5c-53.4 0-96.7-43.3-96.7-96.7 0-53.4 43.3-96.7 96.7-96.7h892.6c53.4 0 96.7 43.3 96.7 96.7 0 53.4-43.3 96.7-96.7 96.7z",
    style: {
      fill: "#f3f3f3"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1004.1 453.3v382.3c0 17-13.8 30.7-30.7 30.7H426.7c-17 0-30.7-13.8-30.7-30.7V453.3h608.1m15.9-16H380v398.3c0 25.8 20.9 46.7 46.7 46.7h546.6c25.8 0 46.7-20.9 46.7-46.7V437.3z",
    className: "Wishlist-empty_svg__st3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M699.9 715.5c-75.1 0-136.2-61.1-136.2-136.2v-63.6c0-4.4 3.6-8 8-8s8 3.6 8 8v63.6c0 66.3 53.9 120.2 120.2 120.2s120.2-53.9 120.2-120.2v-63.6c0-4.4 3.6-8 8-8s8 3.6 8 8v63.6c0 75.1-61.1 136.2-136.2 136.2zM999.7 438.1h-16V280.5H417.8v157.6h-16V264.5h597.9z",
    className: "Wishlist-empty_svg__st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M488.4 438.1h-16v-98.2l-68-61.5 10.8-11.8 73.2 66.3z",
    className: "Wishlist-empty_svg__st3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m403.56 420.164 70.569-88.77 12.525 9.957-70.57 88.77zM929.8 438.1h-16V332.9l73.2-66.3 10.8 11.8-68 61.5z",
    className: "Wishlist-empty_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m914.541 341.385 12.525-9.957 70.569 88.77-12.525 9.956zM624.7 438.1h149.1C833.2 394 892.2 325.4 892.2 254c0-54.9-46.4-101.4-101.4-101.4-32.1 0-62 15.1-84.4 42.5-2.5 3.1-6.4 4.7-10.3 4.5-4-.2-7.6-2.3-9.7-5.7-15.7-24.7-47.3-41.3-78.6-41.3-54.9 0-101.4 46.4-101.4 101.4 0 71.4 59 140 118.3 184.1z",
    className: "Wishlist-empty_svg__st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M736.9 374.3h-70.4c-5 0-9-4-9-9s4-9 9-9h70.4c5 0 9 4 9 9s-4 9-9 9z",
    className: "Wishlist-empty_svg__st4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M701.7 99c-4.4 0-8-3.6-8-8V49.1c0-4.4 3.6-8 8-8s8 3.6 8 8V91c0 4.4-3.6 8-8 8zM743.3 99c-4.4 0-8-3.6-8-8V70c0-4.4 3.6-8 8-8s8 3.6 8 8v21c0 4.4-3.6 8-8 8zM779.3 99c-4.4 0-8-3.6-8-8V80.5c0-4.4 3.6-8 8-8s8 3.6 8 8V91c0 4.4-3.6 8-8 8zM665.3 99c-4.4 0-8-3.6-8-8V70c0-4.4 3.6-8 8-8s8 3.6 8 8v21c0 4.4-3.6 8-8 8zM629.3 99c-4.4 0-8-3.6-8-8V80.5c0-4.4 3.6-8 8-8s8 3.6 8 8V91c0 4.4-3.6 8-8 8z",
    className: "Wishlist-empty_svg__st3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 641.2,
    cy: 274.6,
    r: 19.8,
    className: "Wishlist-empty_svg__st4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.9,
    cy: 274.6,
    r: 19.8,
    className: "Wishlist-empty_svg__st4"
  })));
};
export default SvgWishlistEmpty;